import React from "react"
import { Button, Card, Col, Row } from "react-bootstrap"

export function CardOffer(props) {
    const { navigate } = props;
    return (
        <Card className='bg-theme-ternary b-theme-ternary'>
            <Card.Body style={{ 'overflow': "hidden", 'maxHeight': 150 }} className="pt-0">
                <Row>
                    <Col sm={5} md={5} className={"d-none d-sm-block pt-3"}>
                        <Card.Title className='fs-5 d-none d-xs-none d-sm-none d-md-none d-lg-none d-xl-block d-xxl-block'>Oferta Especial</Card.Title>
                        <Card.Title className='fs-6 d-none d-xs-none d-sm-none d-md-block d-lg-block d-xl-none d-xxl-none'>Oferta Especial</Card.Title>
                        <Button
                            variant="primary"
                            className='bg-theme-secondary b-theme-secondary mt-3 text-nowrap'
                            size='sm'
                            onClick={
                                () => navigate(`/product/${props.data.url}`)
                            }
                        >
                            <small>{props.data.text}</small>
                        </Button>
                    </Col>
                    <Col sm={7} md={7} className="p-0">
                        <img className="d-block w-100" src={props.data.imageURL} alt="" />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}